import React from 'react';
import { Loader, AlertTriangle } from 'lucide-react';
import SignalementCard from './SignalementCard';

const SignalementList = ({ signalements, loading, onView, onUpdateStatus }) => {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <Loader size={48} className="text-[#FF6B00] animate-spin mb-4" />
        <p className="text-gray-600">Chargement des signalements...</p>
      </div>
    );
  }

  if (!signalements || signalements.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-sm p-12 text-center">
        <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <AlertTriangle size={40} className="text-gray-400" />
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          Aucun signalement trouvé
        </h3>
        <p className="text-gray-600">
          Aucun signalement ne correspond à vos critères de recherche.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {signalements.map((signalement) => (
        <SignalementCard
          key={signalement.id}
          signalement={signalement}
          onView={onView}
          onUpdateStatus={onUpdateStatus}
        />
      ))}
    </div>
  );
};

export default SignalementList;
